// extracted by extract-css-chunks-webpack-plugin
module.exports = {"itemPriceData":"GnbE4","tRed":"_7J9oc"};